import { hexToRGB } from '@repo-level/core-front';
import { ScMoreBtn } from 'components/BonusCard/styled';
import { ScCMSTextBlock } from 'components/styles/common';
import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components/macro';

interface IScSeoContentProps {
  isOpen: boolean;
}

export const ScFaqSection = styled.div`
  margin-top: 32px;
`;

export const ScFaqSectionTitle = styled.div`
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.01em;
  color: ${({ theme }) => theme.whiteColor};
  text-align: start;
  margin-bottom: 12px;

  @media (${device.mobile}) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const ScSeoContent = styled.div<IScSeoContentProps>`
  position: relative;
  border-top: ${({ theme }) => `1px solid ${theme.grayColor6}`};

  & > .content {
    position: relative;
    overflow: hidden;
    padding-bottom: 16px;

    @media (${device.mobile}) {
      padding-bottom: 24px;
    }

    ${ScCMSTextBlock} {
      color: #9a9cac;
      row-gap: 0;

      img {
        height: 208px;
        border-radius: 8px;
        max-width: 675px;
        margin-top: 16px;
        @media (${device.mobile}) {
          height: 106px;
        }
      }

      & table {
        width: 100%;
        border-collapse: collapse;
        text-align: center;
        margin-top: 16px;

        th,
        td {
          border: ${({ theme }) => `1px solid ${theme.grayColor6}`};
          padding: 5px 12px;
          font-size: 14px;
          line-height: 22px;
        }

        th {
          color: ${({ theme }) => theme.whiteColor};
          font-weight: 700;
          padding: 6px 12px;
        }
      }

      & p {
        font-size: 14px;
        line-height: 22px;
        margin-top: 16px;

        & + ul,
        & + ol {
          margin-top: 16px;
        }

        & + h3 {
          margin-bottom: 0;
        }
      }

      & ul {
        & + h3 {
          margin-bottom: 0;
        }
      }

      & blockquote {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 24px 8px;
        flex-direction: column;
        padding: 16px;
        background-color: rgba(31, 32, 44, 0.4);
        text-align: center;
        border-radius: 8px;
        gap: 8px;
        & > cite {
          font-weight: 700;
          color: ${({ theme }) => theme.whiteColor};
          font-style: normal;
        }
      }

      & ul > li {
        line-height: 20px;
        margin: 8px 0;
      }

      hr {
        background-color: ${({ theme }) => theme.grayColor6};
        border: none;
        height: 1px;
        margin: 16px 0;
      }

      a {
        color: ${({ theme }) => theme.blueColor};
      }

      hr + p,
      hr + h1,
      hr + h2,
      hr + h3,
      hr + h4,
      hr + h5,
      hr + h6 {
        margin-top: 0;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        text-align: start;
        color: ${({ theme }) => theme.whiteColor};
      }

      h1 {
        margin-top: 16px;
        & + p {
          margin-top: 0;
        }
      }

      h2 {
        &:first-child {
          margin-top: 16px;
        }
        margin-top: 32px;
      }



      h3 {
        margin-top: 16px;

        & + p {
          margin-top: 16px;
        }
      }
      
    }

    &::after {
      content: "";
      position: absolute;
      top: 100px;
      left: 0;
      height: 120px;
      width: 100%;
      background: ${({ theme }) => `linear-gradient(
        180deg,
        ${hexToRGB(theme.grayColor4, 0.1)} 0%,
        ${hexToRGB(theme.grayColor4, 0.8)} 47.91%,
        ${theme.grayColor4} 100%
      )`};
      opacity: ${({ isOpen }) => (isOpen ? 0 : 1)};
      transition: opacity 0.5s ease-in-out;
      pointer-events: none;

      @media (${device.mobile}) {
        top: 80px;
        height: 84px;
      }
    }
  }

  & > .btn_wrapper {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);

    bottom: ${({ isOpen }) => (isOpen ? '-20px' : '-8px')};

    ${ScMoreBtn} {
      margin-top: 0;

      @media (${device.mobile}) {
        height: auto;
        padding-top: 16px;
      }
    }
    & > div {
      margin-left: 0;
    }

    @media (${device.mobileS}) {
      bottom: -25px;
    }
  }
`;
